import React from 'react';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {LicenseInfo} from '@mui/x-license';

// @ts-ignore
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUIX_LICENCE_KEY);

import {createRoot} from 'react-dom/client';
import {RecoilRoot} from 'recoil';
import {reloadOnceOnStaleChunk} from './common/chunkReload';

// After a deploy, a browser holding stale HTML requests hashed chunk files
// that no longer exist. Reload once (cooldown-guarded) to pick up the fresh
// build instead of leaving the user on a broken page. React.lazy import
// failures surface as rejected promises, so cover both surfaces.
window.addEventListener('error', (e) =>
  reloadOnceOnStaleChunk(e?.error ?? e?.message ?? ''),
);
window.addEventListener('unhandledrejection', (e) =>
  reloadOnceOnStaleChunk(e?.reason ?? ''),
);

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <RecoilRoot>
    <App />
  </RecoilRoot>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
